/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnergyBalanceResponse } from '../../models/energy-balance-response';

export interface GetEnergyBalances$Params {
  location_id: string;
  aggregation?: string;
  at?: string;
  from?: string;
  to?: string;
}

export function getEnergyBalances(http: HttpClient, rootUrl: string, params: GetEnergyBalances$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnergyBalanceResponse>>> {
  const rb = new RequestBuilder(rootUrl, getEnergyBalances.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('aggregation', params.aggregation, {});
    rb.query('at', params.at, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EnergyBalanceResponse>>;
    })
  );
}

getEnergyBalances.PATH = '/locations/{location_id}/energy-balances';
